import { root as yupRoot, enrich, } from '../yupWrapper';
const enrichWithExtentions = (extensions, root) => {
    Object.entries(extensions).forEach(([methodName, method]) => {
        enrich(root.object, methodName, method);
    });
    return root.object;
};
const validatePropsSchema = (propsSchema) => {
    const isPropSchema = (_s) => true;
    // Object.entries(propsSchema).forEach(([propName, schema]) => {
    Object.entries(propsSchema).forEach(([_, schema]) => {
        if (!isPropSchema(schema)) {
            return;
        }
        // TODO: Uncomment once defaults issue is resolved
        // const isDefaultValueDefined = schema.default() !== undefined;
        // if (!isDefaultValueDefined) {
        //   throw new Error(
        //     `prop '${propName}' was not properly defined, every prop *must* have a default value.`,
        //   );
        // }
    });
};
export const createSchema = (defineSchema, { isDraftSchema } = {}, defaultSchema) => {
    const schema = (defaultSchema
        ? Object.assign(Object.assign({}, defaultSchema({ schemaBuilder: yupRoot })), (defineSchema && defineSchema({ schemaBuilder: yupRoot }))) : Object.assign({}, (defineSchema && defineSchema({ schemaBuilder: yupRoot }))));
    validatePropsSchema(schema);
    return yupRoot.object(schema).meta({ isDraftSchema });
};
export const createPropsSchema = (defineSchema, extensions) => {
    const props = defineSchema({ schemaBuilder: yupRoot });
    validatePropsSchema(props);
    const rootConstructor = enrichWithExtentions(extensions, yupRoot);
    return rootConstructor(props);
};
//# sourceMappingURL=builder.js.map